const V = (import.meta as any).env || {};

/**
 * Базовый адрес API.
 *
 * Пустая строка здесь — осмысленное значение: она означает относительные
 * пути (/api/v1/...), и бандл перестаёт зависеть от домена. Ровно этого
 * добивался коммит 792574c.
 *
 * Поэтому ??, а не ||. Пустая строка в JavaScript ложна, и цепочка на ||
 * проваливалась мимо обеих переменных до localhost. 2026-08-21 это увело
 * боевую панель на http://localhost:8001 — выражение было размножено по
 * пяти файлам, и правка одного места положения не спасала.
 *
 * localhost остаётся запасным вариантом только когда переменная не задана
 * вовсе, то есть при разработке без .env.
 */
export function resolveApiBase(fallback = "http://localhost:8001"): string {
  return V?.VITE_API_URL ?? V?.VITE_API_BASE_URL ?? fallback;
}

export const apiBase = resolveApiBase();
